import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Paper,
  Link,
  darken,
} from "@mui/material";
import { iresoftColors } from "../../../theme/ireColors";
import { useTranslation } from "react-i18next";

const LOCALSTORAGE_KEY = "irebook_welcome_popup_shown";

const IrebookWelcomePopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const alreadyShown = localStorage.getItem(LOCALSTORAGE_KEY);
    if (!alreadyShown) {
      setOpen(true);
      localStorage.setItem(LOCALSTORAGE_KEY, "true");
    }
  }, []);

  const handleClose = () => setOpen(false);
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
          bgcolor: "background.paper",
        },
      }}
    >
      <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
        <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 2 }}>
          {t("pages.welcome.dialog.welcomeText")}
        </Typography>
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            borderRadius: 2,
            mt: 2,
            bgcolor: "background.default",
          }}
        >
          <Typography variant="subtitle2" sx={{ lineHeight: 1.6 }}>
            {t("pages.welcome.dialog.infoTextAdd")}{" "}
            <Link
              href="https://www.iresoft.cz/irebook"
              underline="hover"
              target="_blank"
              rel="noopener"
            >
              iresoft.cz/irebook
            </Link>
            .
          </Typography>
        </Paper>
      </DialogContent>

      {/* Footer */}
      <DialogActions sx={{ justifyContent: "center", py: 2 }}>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            px: 3,
            py: 1,
            width: "40%",
            backgroundColor: iresoftColors.iresoftRed,
            color: iresoftColors.white,
            borderRadius: 4,
            "&:hover": {
              backgroundColor: darken(iresoftColors.iresoftRed, 0.15),
            },
          }}
          onClick={handleClose}
        >
          {t("pages.welcome.dialog.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IrebookWelcomePopup;
